import WiseView from '../../WiseView.vue';
import { frontendURL } from '../../../../../helper/URLHelper';
import ConnectionWise from './ConnectionWise.vue';
export const routes = [
  {
    path: frontendURL('accounts/:accountId/wise/connection'),
    name: 'wise',
    roles: ['administrator'],
    component: WiseView,
    children: [
      {
        path: '',
        name: 'connection_wise',
        component: ConnectionWise,
        roles: ['administrator'],
      },
    ],
  },
];
